// extracted by mini-css-extract-plugin
export default {"container":"Container_container__MM274","ProductsBlock":"Container_ProductsBlock__2J4MY","Product":"Container_Product__Y+VQb"};